import React from "react";
import {
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonAvatar,
  IonLabel,
  IonItem,
  IonList,
  IonBadge,
} from "@ionic/react";

interface SchedulerRankingProps {
  rankingList: Array<{
    schedulerUID: string;
    schedulerName: string;
    schedulerPICURL: string;
    completedJobsCount: number;
  }>;
}

export const SchedulerRanking: React.FC<SchedulerRankingProps> = ({ rankingList }) => {
  return (
    <IonCard>
      <IonCardHeader>
        <IonCardTitle>Scheduler Rankings (Last 45 Days)</IonCardTitle>
      </IonCardHeader>
      <IonCardContent>
        <IonList>
          {rankingList.map((scheduler, index) => (
            <IonItem key={scheduler.schedulerUID}>
              <IonBadge slot="start" color={index === 0 ? "warning" : "medium"}>
                #{index + 1}
              </IonBadge>
              <IonAvatar slot="start">
                <img 
                  src={scheduler.schedulerPICURL || "../assets/profilePic.png"} 
                  alt={scheduler.schedulerName} 
                />
              </IonAvatar>
              <IonLabel className="ion-text-wrap">
                <h2>{scheduler.schedulerName}</h2>
                <p>UID: {scheduler.schedulerUID}</p>
              </IonLabel>
              <IonBadge slot="end" color="medium">
                {scheduler.completedJobsCount} jobs
              </IonBadge>
            </IonItem>
          ))}
        </IonList>
      </IonCardContent>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </IonCard>
  );
};